import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/60">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          <div className="md:col-span-1">
            <Link to="/" className="flex items-center gap-2.5 mb-4 cursor-pointer">
              <div className="w-8 h-8 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-file-list-3-line text-white text-base"></i>
              </div>
              <span className="font-heading font-bold text-base text-foreground-900 whitespace-nowrap">
                VigorBuy Spreadsheet
              </span>
            </Link>
            <p className="text-sm text-foreground-500 leading-relaxed">
              Your trusted resource for organized product research guides and comparison tools. Updated for 2026.
            </p>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-sm text-foreground-900 mb-4">Quick Links</h4>
            <ul className="space-y-2.5">
              <li><Link to="/" className="text-sm text-foreground-500 hover:text-primary-600 transition-colors cursor-pointer">Home</Link></li>
              <li><a href="#categories" onClick={(e) => { if (window.location.pathname !== '/') { e.preventDefault(); window.location.href = `${__BASE_PATH__ || ''}/#categories`; } }} className="text-sm text-foreground-500 hover:text-primary-600 transition-colors cursor-pointer">Categories</a></li>
              <li><a href="#how-it-works" onClick={(e) => { if (window.location.pathname !== '/') { e.preventDefault(); window.location.href = `${__BASE_PATH__ || ''}/#how-it-works`; } }} className="text-sm text-foreground-500 hover:text-primary-600 transition-colors cursor-pointer">How It Works</a></li>
              <li><a href="#comparison" onClick={(e) => { if (window.location.pathname !== '/') { e.preventDefault(); window.location.href = `${__BASE_PATH__ || ''}/#comparison`; } }} className="text-sm text-foreground-500 hover:text-primary-600 transition-colors cursor-pointer">Comparison</a></li>
              <li><Link to="/article/vigorbuy-spreadsheet-safety-guide" className="text-sm text-foreground-500 hover:text-primary-600 transition-colors cursor-pointer">Safety Guide</Link></li>
              <li><Link to="/article/vigorbuy-spreadsheet-comparison-guide" className="text-sm text-foreground-500 hover:text-primary-600 transition-colors cursor-pointer">Comparison Guide</Link></li>
              <li><Link to="/article/vigorbuy-spreadsheet-beginner-tips-guide" className="text-sm text-foreground-500 hover:text-primary-600 transition-colors cursor-pointer">Beginner Tips</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-sm text-foreground-900 mb-4">Popular Categories</h4>
            <ul className="space-y-2.5">
              {categories.slice(0, 6).map((cat) => (
                <li key={cat.id}>
                  <a
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-foreground-500 hover:text-primary-600 transition-colors cursor-pointer"
                  >
                    {cat.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-sm text-foreground-900 mb-4">More Categories</h4>
            <ul className="space-y-2.5">
              {categories.slice(6, 12).map((cat) => (
                <li key={cat.id}>
                  <a
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-foreground-500 hover:text-primary-600 transition-colors cursor-pointer"
                  >
                    {cat.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-background-200/60 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-400">
            &copy; {new Date().getFullYear()} VigorBuy Spreadsheet. All product links redirect to kaspreadsheet.com.
          </p>
          <div className="flex items-center gap-6">
            <Link to="/" className="text-xs text-foreground-400 hover:text-primary-600 transition-colors cursor-pointer">Home</Link>
            <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-xs text-foreground-400 hover:text-primary-600 transition-colors cursor-pointer">
              Main Store
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}